module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_salon-e888938713b5d2e89f38bb4ec7406790.png";